export default __webpack_public_path__ + "media/images/onglettitre-liste-cfcd61ea97572041fa8e177ff0b417cc.png";